<template>
  <main class="main home">
    <slideshow></slideshow>
    <novita></novita>
    <div class="module col-2 stretch-parent max-width side-padding">
      <featuredVideo></featuredVideo>
      <registerBanner01></registerBanner01>
    </div>
    <homeCatalogue></homeCatalogue>
  </main>
</template>

<script>
import Slideshow from './Slideshow.vue'
import Novita from './Novita.vue'
import FeaturedVideo from './FeaturedVideo.vue'
import RegisterBanner01 from './RegisterBanner01.vue'
import HomeCatalogue from './HomeCatalogue.vue'

export default {
  name: 'Home',
  components: {
    'slideshow': Slideshow,
    'novita': Novita,
    'featuredVideo': FeaturedVideo,
    'registerBanner01': RegisterBanner01,
    'homeCatalogue': HomeCatalogue
  },

  mounted() {
    document.title = 'Caramba - Homepage';
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/vue/components/Home.vue